import React, { Component } from "react";

import installed_img from "../../images/installed.png";

import "../../index.css";

import swal from "@sweetalert/with-react";

export default class Install extends Component {
  constructor(props) {
    super(props);

    this.state = {
      installed: false,
      language: props.language,
      platform: localStorage.getItem("platform"),
      os_version: localStorage.getItem("os_version")
    };

    this.beforeListener = null;
    this.deferredPrompt = null;

    this.changeLanguage = (e) => {
      if (this.state.platform === "ios") {
        if (parseInt(this.state.os_version) >= 13) {
          this.promptIOS(e);
        } else {
          this.promptIOS(e);
        }
      }
    
      if (this.state.platform === "android") {
        this.promptANDROID(e);
      }
    };

  }
  //------------------------------------------------------------------------------------------

  componentDidMount() {

    this.promptLanguage();
  
    window.addEventListener("beforeinstallprompt", (ev) => {
      ev.preventDefault();
      this.deferredPrompt = ev;
    });

    window.addEventListener('appinstalled', (evt) => {
      this.setState({ installed: true });
      swal.close();
    });

    
  }

  componentWillUnmount() {
    window.removeEventListener("beforeinstallprompt", this.beforeListener);
  }

  promptLanguage = () => {
    swal({
      buttons: {},
      closeOnEsc: false,
      closeOnClickOutside: false,
      content: (
        <div>
          <button
            className="boton-en"
            onClick={() => this.changeLanguage("en")}
          />
          <button
            className="boton-es"
            onClick={() => this.changeLanguage("es")}
          />
        </div>
      ),
    });
  };

  promptIOS = (e) => {
    const icono = this.props.server + "/icons/icon-192x192.png";
    let titulo = "App Install";
    if (e === "es"){titulo = "Instalar Aplicación";localStorage.setItem('language', 'es');}
    let desc1 = "Just tap ";
    if (e === "es") desc1 = "Toque ";
    let desc2 = " and then select";
    if (e === "es") desc2 = " y entonces seleccione";
    let desc3 = ' "Add to Home Screen"';
    if (e === "es") desc3 = ' "Agregar a Inicio"';
    swal({
      title: titulo,
      icon: icono,
      buttons: {},
      closeOnEsc: false,
      closeOnClickOutside: false,
      content: (
        <div>
          <span style={{ color: "#808080" }}>{desc1}</span>
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAActpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+QWRvYmUgSW1hZ2VSZWFkeTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KKS7NPQAAAsxJREFUSA2lVjFrFFEQnnm7l2iiF2LuEggWImchFjb5B4KFhZ3+AC1io1hZJedyYGNjERANaB9FG0FBBGuLIBamukYQRXN4GnKSy+6+cebt283buz3dmIF3O2/ezHwz82ZnD+BfdIm8VKW+vLsmK92Dc5bJ9sUEpFL9+nL4bPYOkSzhUzk4OpnMYdDh86wYBqjFQU1HrxGoDoA9qzRBAJ2O8s+nOuaZ92B2xQBECIh0JqCxbzp6yUpnp7r+8a1j8WMADdUfn678mj7xmUE+zCn/wscAd8HaDGJkJRg8kH0XvvqI8A6VPtdewT6LjrCfo+2VU32RyVkXwC+yHSHjyCUSWQW1rTej57KGjEU3tQO2dchBlwMk2DvmCpQkc1eurvXFogTgCbfiZYxrSzsXUal7DBQDmPaMEPiOgR51WpVbLMsCqjXDuwrwKoHuAChuZdJiQ6Budlr4AqzPxOANyF3EgF6DL/ckkb7GNpMQx2I0gYjvJT5OjvcJcRe8JaKfnOZv8FCB1j1E7wEQNIyG9ZkAzLNYCBUh6Y3N1thDsx/4YaUMYLPlv+JjWRnNNsMbnEGytz6zlFMtjuqw4blF4UsC3BgHJV1Ezg01rtN4u28B5zk5blVju3eHxk0egDRnbrO5DaG8C6LVDpLac6mSTEU2wyUNMDJeTNcxJ7biw6E8gHNQxHKEOeMiHSmzK98XACobsethkD9gBtOD/ob2/5mB6R6llPsWZx01BOIIypXITtXvAd43tumkdRyNYssBiLWApB+YQN70clQeQPw9Le84hf/ruE6VDvLMZ2A6wLbx4rrPA6vURcLiugQa8tAbiiUPwOORh1ZS39WFEFaH9EcJEhsSW/4MOZQDQB2LQnVmiU77GFYjz44Nx6CI9XkOR1TZ4t8qT4sEzCrmAFi2rSb9OdyBDVIVyP6vFHl1ZPLl8LiYeMgH3Qu3nSP4A9EHFXrGnVaNAAAAAElFTkSuQmCC"></img>
          <span style={{ color: "#808080" }}>{desc2}</span>
          <br></br>
          <span style={{ color: "#808080", fontWeight: "bold" }}>{desc3}</span>
        </div>
      ),
    });
  };

  promptANDROID = (e) => {
    const icono = this.props.server + "/icons/icon-192x192.png";
    let titulo = "App Install";
    if (e === "es"){titulo = "Instalar Aplicación";localStorage.setItem('language', 'es');}
    let desc1 = "Just tap ";
    if (e === "es") desc1 = "Toque ";
    let desc2 = " and then select";
    if (e === "es") desc2 = " y entonces seleccione";
    let desc3 = ' "Add to Home Screen"';
    if (e === "es") desc3 = ' "Agregar a la Pantalla Principal"';
    swal({
      title: titulo,
      icon: icono,
      buttons: {},
      closeOnEsc: false,
      closeOnClickOutside: false,
      content: (
        <div>
          <span style={{ color: "#808080" }}>{desc1}</span>
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAUElEQVQ4T2NkoBAw4tPPLy7vBJL/+PLhPlzq8BogIKnwHqTxw/MHgmQZQLELiAkevF4YeAMEJBQPgwPxxX1bsgKRYgMGPgwodgHFCWloJGUAn3ggEbQ7VpAAAAAASUVORK5CYII="></img>
          <span style={{ color: "#808080" }}>{desc2}</span>
          <br></br>
          <span style={{ color: "#808080", fontWeight: "bold" }}>{desc3}</span>
        </div>
      ),
    });
  };

  //------------------------------------------------------------------------------------------
  
  render() {
    const alto = window.innerHeight;
    if (!this.state.installed) {
      return (
        <div className="container_login" style={{ width: "100%", height: "100%" }} >
        </div>
      );
    } else {
      return (
        <div style={{width:'100%',height:alto,display: 'flex',flexDirection: 'row',justifyContent: 'center',alignItems: 'center', overflow: 'hidden'}}>
          <img src={installed_img} alt="" style={{width:'30%'}} />           
        </div>  
      );
    }
  }
}
